import axios from "axios";
import { toast } from "react-toastify";

import { redirectToLogin } from "../errorHandeling";

/*
 * Global cross-cutting handling for EVERY request made through the default
 * axios instance (all call sites use it). Installed once at app startup.
 *
 * It performs SIDE-EFFECTS ONLY and then RE-THROWS the error, so every existing
 * catch block / inline field message keeps working unchanged — this is purely
 * additive, never a replacement for a component's own error handling.
 *
 * Note: the login flow uses its own axios.create() instance (useLogin.js), so a
 * wrong-password 401 there does NOT hit this interceptor — only session-expiry
 * 401s on authenticated requests trigger the redirect.
 */

// Throttle identical global toasts so a burst of failing requests can't stack
// duplicates on screen.
let lastToast = { msg: "", at: 0 };

const toastOnce = (msg) => {
  const now = Date.now();
  if (msg === lastToast.msg && now - lastToast.at < 4000) return;
  lastToast = { msg, at: now };
  toast.error(msg, { position: "bottom-right", autoClose: 5000, theme: "light" });
};

let installed = false;

export default function setupAxiosInterceptors() {
  if (installed) return; // guard against double-install (StrictMode / HMR)
  installed = true;

  axios.interceptors.response.use(
    (response) => response,
    (error) => {
      if (axios.isAxiosError(error)) {
        // Network error — no response at all (server unreachable / no internet).
        if (error.code === "ERR_NETWORK") {
          toastOnce("تعذر الاتصال بالخادم، يرجى التحقق من اتصالك بالإنترنت");
        } else if (error.response) {
          const status = error.response.status;

          if (status === 401) {
            // Session expired / invalid token: clear session + go to login.
            // Uses errorHandeling's one-shot guard, so it fires only once even
            // when many requests 401 together, and never double-redirects with
            // a catch block that also calls errorHandeling().
            redirectToLogin();
          } else if (status >= 500) {
            toastOnce("هناك خطأ في الخادم، يرجى المحاولة لاحقاً");
          }
        }
      }

      // Always re-throw: components still receive the error for their own UI.
      return Promise.reject(error);
    }
  );
}
